// Mock data for The Career Counsellor clone
// NOTE: All content below is MOCKED on the frontend for the teaser build.

export const navLinks = [
  { label: "Home", id: "home" },
  { label: "Services", id: "services" },
  { label: "For Schools", id: "schools" },
  { label: "Why Us", id: "why" },
  { label: "Reviews", id: "reviews" },
  { label: "Contact", id: "contact" },
];

export const heroImages = [
  "https://images.unsplash.com/photo-1541339907198-e08756dedf3f",
  "https://images.unsplash.com/photo-1627556704290-2b1f5853ff78",
];

// Four top feature pillars
export const pillars = [
  {
    icon: "Users",
    title: "Career Counselling",
    text: "Career counseling is a collaborative process where a trained counselor helps individuals identify strengths, interests, and skills to make informed decisions about their education, career path, and professional development. It involves using assessments, discussing aspirations, exploring career options, and creating a strategic plan for achieving educational and career goals.",
  },
  {
    icon: "GraduationCap",
    title: "Domestic Education",
    text: "Domestic higher education refers to the system of colleges, universities, and other institutions that provide education and training after high school within India. Higher education encompasses a vast network of State Public Universities and affiliated colleges. NEP 2020 aims to increase enrollment and expand access to quality higher education.",
  },
  {
    icon: "Globe",
    title: "Study Abroad",
    text: "Studying abroad is an international educational opportunity to earn a degree or gain experience at a foreign university, offering cultural immersion, personal growth, and enhanced career prospects. The process involves researching destinations, meeting academic and language requirements like IELTS, applying to universities and securing a student visa.",
  },
  {
    icon: "BrainCircuit",
    title: "Psychometric Test",
    text: "A psychometric test is a scientific and objective assessment designed to measure a person's personality traits, cognitive abilities, and aptitude to gauge their suitability for a particular role or to understand their strengths and weaknesses. These tests are widely used in hiring and education to provide standardized insights.",
  },
];

// Our Services (illustrated cards)
export const services = [
  {
    image:
      "https://images.unsplash.com/photo-1698047682091-782b1e5c6536?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    title: "Career Counselling for Schools",
    text: "Career counseling in schools is a process where trained professionals help students understand themselves, explore career options, and make informed decisions about their future education and work. It involves psychometric assessments to identify interests, strengths, and values, which guides students in choosing suitable career paths and developing lifelong career management skills.",
  },
  {
    image:
      "https://images.unsplash.com/photo-1514369118554-e20d93546b30?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    title: "Self Assessment for Students",
    text: "Self-assessment in career counseling is the process of understanding your own skills, interests, values, and personality to gain a sense of direction and make informed career decisions. It involves reflecting on past experiences and using tools like questionnaires, personality tests, and feedback from others to identify strengths, weaknesses, motivations, and what truly matters to you.",
  },
  {
    image:
      "https://images.unsplash.com/photo-1517971129774-8a2b38fa128e?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    title: "Career Exploration for Students",
    text: "Career exploration for students is a multi-step process of self-discovery and research to find careers that align with their interests, skills, and values, leading to a strategic plan for future goals. Key activities include self-assessment, extensive research of occupations, and gaining real-world experience through internships, apprenticeships, and job shadowing.",
  },
];

export const schoolSteps = [
  { step: "Step 1", title: "Self-Discovery", text: "Reflecting on personal values, interests, and strengths to build self-awareness." },
  { step: "Step 2", title: "Explore Opportunities", text: "Discovering a wide range of career opportunities and pathways available." },
  { step: "Step 3", title: "Choose a Career", text: "Choosing a suitable career option aligned with abilities and aspirations." },
  { step: "Step 4", title: "Curate a Plan", text: "Curating a strategic career plan with clear, achievable milestones." },
];

export const schoolImage =
  "https://images.unsplash.com/photo-1549057446-9f5c6ac91a04?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";

export const reviewsImage =
  "https://images.unsplash.com/photo-1549057446-9f5c6ac91a04?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";

export const reviews = [
  {
    name: "Ananya Sharma",
    role: "Class 12 Student",
    text: "The sessions helped me understand my true interests. I finally feel confident about choosing engineering with clarity, not pressure.",
    rating: 5,
  },
  {
    name: "Rahul Verma",
    role: "Undergraduate",
    text: "The psychometric test was eye-opening. My counsellor guided me to a path that genuinely matches my strengths.",
    rating: 5,
  },
  {
    name: "Meera Nair",
    role: "Parent",
    text: "As a parent, I was anxious about my daughter's future. The personalised guidance here gave our whole family peace of mind.",
    rating: 5,
  },
];

export const whyChoose = [
  {
    icon: "HeartHandshake",
    title: "Passionate",
    text: "Passionate career counselling where our professional guides you to discover a career path that aligns with your personal interests, values, and strengths, helping you balance these passions with market demand and financial viability.",
  },
  {
    icon: "BadgeCheck",
    title: "Professional",
    text: "Professional career counselling is a systematic process where trained experts provide personalized guidance to help you understand your strengths, interests, and values to make informed decisions about your education and career path.",
  },
  {
    icon: "LifeBuoy",
    title: "Support",
    text: "Comprehensive assistance and guidance provided by our professional career counsellor across self-exploration, career exploration, decision-making, and managing career changes — using assessments, resources, and confidence-building.",
  },
];

export const contact = {
  phone: "+91 99933 00949",
  email: "support@thecareercounsellor.in",
  instagram: "https://instagram.com",
};
